import { ClikDataFormOut } from "../../../components/ClikDataInfoForm/types.ts";
import { UpdateClikCompanyDataInput } from "../../../graphql/generated.ts";
import { formatToCreateCompanyDataInput } from "../../ClikDataCreate/utils.ts";

export const formatToUpdateClikDataInput = (
  data: ClikDataFormOut
): UpdateClikCompanyDataInput => {
  return formatToCreateCompanyDataInput(data);
};
